var $75bc5191b9d7826a$exports = {};
$75bc5191b9d7826a$exports = {
    "close": `Sule`,
    "notifications": `Teated`
};


export {$75bc5191b9d7826a$exports as default};
//# sourceMappingURL=et-EE.mjs.map
